import React from "react";
import Spinner from "./Spinner";
import { colors, typography } from "../../styles/index";

export default function LoadingOverlay({ message = "Loading..." }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(255, 255, 255, 0.75)",
        backdropFilter: "blur(1px)",
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <div
        role="status"
        aria-live="polite"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 10,
          background: colors.white,
          border: `1px solid ${colors.border}`,
          borderRadius: 12,
          padding: "12px 16px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
        }}
      >
        <Spinner
          size={18}
          color={colors.primary}
          trackColor="rgba(29, 78, 216, 0.2)"
        />
        <span style={{ ...typography.small, color: colors.textMuted }}>
          {message}
        </span>
      </div>
    </div>
  );
}
